import React from 'react';
import trash from '../../../../static/icons/trash.svg';
import CellTrigger from '../../Menu/MenuTriggers/CellTrigger';
import { RootState } from '../../../../state/store/store';
import { connect } from 'react-redux';
import { singleShipmentSelectors } from '../../../../state/ducks/singleShipment/selectors';
import { shipment } from '../../../../models/entities/shipment/shipment';
import Menu from '../../Menu/Menu';
import MenuItem from '../../Menu/MenuItem';
import { userSelectors } from '../../../../state/ducks/user/selectors';
import claimsType from '../../../../models/entities/claimsType';
import { userInfo } from '../../../../models/entities/user';
import { claimsDomainsType } from '../../../../userClaims';

type onRowMoreOptionClickType = () => void;
type deleteShipmentInternalDocumentType = (shipmentNumber: string, documentId: number) => void;

type Props = {
    entityId: string;
    userId: string;
    localization: any;
    onRowMoreOptionsClick?: onRowMoreOptionClickType;
    deleteShipmentInternalDocument: deleteShipmentInternalDocumentType;
    getUserClaims: (domain: claimsDomainsType) => claimsType;
    shipment?: shipment;
    userInfo: userInfo;
};

const ShipmentInternalDocumentMenu = ({
    entityId,
    userId,
    shipment,
    localization,
    getUserClaims,
    userInfo,
    onRowMoreOptionsClick,
    deleteShipmentInternalDocument
}: Props) => {
    const { delete_document: deleteClaim } = getUserClaims('shipment');
    const isDocumentCreatedByCurrentUser = userId === userInfo.id;

    const deleteItem = (
        <MenuItem onClick={() => shipment && deleteShipmentInternalDocument(shipment.id, parseInt(entityId))} icon={trash} text={localization.delete} />
    );

    const menuItems = (isDocumentCreatedByCurrentUser || deleteClaim) ? [deleteItem] : [];

    return menuItems.length ? (
        <Menu options={menuItems} MenuTrigger={CellTrigger} strStyle="display: flex;align-items: center;width: 100%;height: 100%;" />
    ) : (
        <div></div>
    );
};

const mapStateToProps = (state: RootState) => ({
    shipment: singleShipmentSelectors.shipment(state),
    getUserClaims: (domain: claimsDomainsType) => userSelectors.getUserClaims(state)(domain),
    userInfo: userSelectors.userInfo(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    deleteShipmentInternalDocument: (shipmentNumber: string, documentId: number) =>
        dispatch.shipments.deleteShipmentInternalDocument({ shipmentNumber, documentId }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentInternalDocumentMenu);